import {
  makeColorSchema
} from "./chunk-SNUDSNGS.js";
import "./chunk-EUXUH3YW.js";

// libs/core/src/lib/theme/themes/brand-color-schemes/orange.style.ts
var orangeStyle = makeColorSchema("#ef962e");
export {
  orangeStyle
};
//# sourceMappingURL=orange.style-SHX2AUWW.js.map
